import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../app/store";

export interface vehicleState {
    totalRecords: number | null;
    data: [] | null;
    totalPage: number | null;
    currentPage: number | null;
    saveVehicleData:{} | null;
}

const initialState: vehicleState = {
    data: null,
    totalRecords: null,
    totalPage: null,
    currentPage: null,
    saveVehicleData: null
}

export const vehicleSlice = createSlice({
    name: 'vehicle',
    initialState,
    reducers: {
        setVehicle: (state, action) => {
            state.data = action.payload.data;
            state.currentPage = action.payload.currentPage;
            state.totalPage = action.payload.totalPage;
            state.totalRecords = action.payload.totalRecords;
        },
        addVehicle: (state: any, action) => {
            state.data = [action.payload.data, ...state.data];
        },
        reset: (state) => {
            state = initialState;
        },

    },
});

export const { setVehicle, addVehicle, reset } = vehicleSlice.actions;

export const getVehicleData = (state: RootState) => state.vehicle.data;
export const getVehicleTotalPages=(state:any)=>state.vehicle.totalPage;

export default vehicleSlice.reducer